import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPrescribePractice } from 'api/Prescribe';

export const useGetVeradigmPractice = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(
    ['veradigm-practice', ...dependencies],
    () => getPrescribePractice(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      ...options
    }
  );
};
